import { Component,
         Input,
         Output,
         OnInit,
         OnDestroy,
         EventEmitter } from '@angular/core'

import { RouterService } from 'src/app/_core/index'

@Component({
  selector: 'ss-popup-confirm',
  templateUrl: 'popup-confirm.component.html'
})

export class PopupConfirmComponent implements OnInit, OnDestroy {


  @Input() type = 'confirm' // ['warn','confirm']
  @Input() titleText: string
  @Input() helperText: string
  @Input() warningText: string
  @Input() cancelText = 'Cancel'
  @Input() submitText = 'Submit'

  @Output() onCancel = new EventEmitter<any>()
  @Output() onSubmit = new EventEmitter<any>()

  private resolve$: any

  constructor(
    private routerService: RouterService
  ) {}

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  emitOnCancel() {
    this.closePopup()
    this.onCancel.emit()
  }

  emitOnSubmit() {
    this.closePopup()
    this.onSubmit.emit()
  }

  closePopup() {
    this.routerService.closeOutlet('p')
  }
}
